import axios from 'axios'

/*
 * Zoho client refresh.
 *
 * Was an Angular factory taking `$http` and `ResourceSelectionService` (step 35 of #614). The
 * `ResourceSelectionService` parameter was never used in the body, so it is dropped; the two calls
 * use axios now.
 */
const clientRefreshService = {
  refresh: () => {
    return axios.get('/api/zoho/refresh')
  },

  findClients: clientName => {
    return axios.get('/api/zoho/findClients/' + clientName)
  },
}

export default clientRefreshService
